import { render, staticRenderFns } from "./titulo.vue?vue&type=template&id=56b31091&"
import script from "./titulo.vue?vue&type=script&async=true&lang=js&"
export * from "./titulo.vue?vue&type=script&async=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports